import React from "react";
import Grid from "@mui/material/Grid2";
import { ExtractedObject, fieldLabel } from "./PdfImporter.types";

const SECTION_FIELDS = ["name", "content"];

interface ActiveObjectToolbarProps {
  activeObject: ExtractedObject;
  appendMode: boolean;
  pendingText: string | null;
  activeField: string | null;
  onAppendToggle: () => void;
  onFieldButton: (field: string) => void;
}

export default function ActiveObjectToolbar({
  activeObject,
  appendMode, pendingText, activeField,
  onAppendToggle, onFieldButton,
}: ActiveObjectToolbarProps) {
  const displayName = activeObject.fields["name"];
  const label = displayName ? `Section: ${displayName}` : "New Section";

  return (
    <div style={{ border: "1px solid #c8d8f0", borderRadius: "6px", padding: "0.6rem 0.75rem", background: "#f5f9ff" }}>
      <Grid container spacing={1} alignItems="center" style={{ marginBottom: "0.5rem" }}>
        <Grid>
          <span style={{ fontWeight: "bold", fontSize: "0.9rem", color: "#2a5db0" }}>{label}</span>
        </Grid>
      </Grid>

      {/* Append toggle + field buttons + status hint */}
      <Grid container spacing={1} alignItems="center">
        <Grid>
          <button
            onClick={onAppendToggle}
            title="When on, text is appended to a field's existing value instead of replacing it"
            style={{
              padding: "0.25rem 0.5rem",
              borderRadius: "4px",
              border: "2px solid",
              borderColor: appendMode ? "#4a90d9" : "#ccc",
              background: appendMode ? "#e8f0fb" : undefined,
              cursor: "pointer",
              fontSize: "0.8rem",
            }}
          >
            {appendMode ? "Append: ON" : "Append: OFF"}
          </button>
        </Grid>

        {SECTION_FIELDS.map(field => (
          <Grid key={field}>
            <button
              onClick={() => onFieldButton(field)}
              title={activeObject.fields[field]
                ? appendMode ? `Append to: "${activeObject.fields[field]}"` : `Replace: "${activeObject.fields[field]}"`
                : `Select text then click to assign to ${fieldLabel(field)}`}
              style={{
                padding: "0.25rem 0.5rem",
                borderRadius: "4px",
                border: "2px solid",
                borderColor: activeField === field ? "#4a90d9" : (pendingText ? "#e8a000" : "#ccc"),
                background: activeObject.fields[field] ? "#e8f4e8" : undefined,
                cursor: "pointer",
                fontSize: "0.8rem",
              }}
            >
              {fieldLabel(field)}{activeObject.fields[field] ? (appendMode ? " +" : " ✓") : ""}
            </button>
          </Grid>
        ))}

        <Grid>
          <span style={{ fontSize: "0.8rem", color: pendingText ? "#e8a000" : "#999", fontStyle: "italic" }}>
            {pendingText
              ? `"${pendingText.slice(0, 40)}${pendingText.length > 40 ? "…" : ""}" — click a field to ${appendMode ? "append" : "assign"}`
              : "Select text, then click a field button"}
          </span>
        </Grid>
      </Grid>
    </div>
  );
}